export const TOLERATED_POSITION_DIFF = 400;
